// actions.js
export const FETCH_COMPANY_REQUEST = 'FETCH_COMPANY_REQUEST';
export const FETCH_COMPANY_SUCCESS = 'FETCH_COMPANY_SUCCESS';
export const FETCH_COMPANY_FAILURE = 'FETCH_COMPANY_FAILURE';

export const fetchCompanyRequest = (data) => ({ type: FETCH_COMPANY_REQUEST});
export const fetchCompanySuccess = (data) => ({ type: FETCH_COMPANY_SUCCESS, payload: data });
export const fetchCompanyFailure = (error) => ({ type: FETCH_COMPANY_FAILURE, payload: error });